import React from 'react';
import MainContentContainer from '../../../../v2BaseComponents/MainContentContainer';
import { useOrganizationClientRecords } from '../../../../../hooks/api/useOrganizationClientRecords';
import { AnimateLoadedContent } from '../../../../v2BaseComponents/Loader';
import ClientProfileHistory from '../../../../shared/ClientProfile/ClientProfileHistory';

export type ClientRecordHistoryContentOwnProps = {
    clientMedicalProfileId: string;
};

export type ClientRecordHistoryContentProps = ClientRecordHistoryContentOwnProps & {};

const ClientRecordHistoryContent: React.FC<ClientRecordHistoryContentProps> = (props) => {
    const { isLoadingClientRecordHistory, clientRecordHistory } = useOrganizationClientRecords({
        clientRecordHistoryProfileId: props.clientMedicalProfileId,
    });
    return (
        <AnimateLoadedContent isLoading={isLoadingClientRecordHistory}>
            {() => (
                <MainContentContainer>
                    <ClientProfileHistory history={clientRecordHistory} />
                </MainContentContainer>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(ClientRecordHistoryContent);
